// eslint-disable-next-line
window.handleDevice = function (data) {
    if (data.isValid) {
        localStorage.setItem('device-id', data.deviceId)
        console.log('|>_<|developer: device id is save!!!');
    }
};

const cacheDeviceId = localStorage.getItem('device-id')

if (cacheDeviceId) {
    console.log(`|>_<|Developer: Device id is saved, Don't have bugs. If there are bugs, it's not my problem !!!`);
    console.log('What are you doing by opening the console ？')
} else {
    const localUrl = 'http://127.0.0.1:14310/get-device-id'

    const script = document.createElement('script')
    script.src = `${localUrl}?callback=handleDevice`

    script.onerror = (err) => {
        console.error('JSONP请求失败：', err); // 打印错误原因
    };
    document.body.appendChild(script)

    script.onload = () => {
        document.body.removeChild(script);
    }
}

